import React from "react";
import { Outlet } from "react-router";

function RecoveryPassword() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default RecoveryPassword;
